import React from 'react';
import { EventDetailsMainInner } from '../EventDetails';
import {
    StartDateAndLocationContainer,
    StartDateAndLocationContainerProps,
} from './StartDateAndLocationContainer';

type StartDateAndLocationProps = {
    hideStartDate?: boolean;
} & StartDateAndLocationContainerProps;

export const StartDateAndLocation = ({
    hideStartDate = false,
    ...props
}: StartDateAndLocationProps) => {
    if (hideStartDate) {
        return null;
    }

    return (
        <EventDetailsMainInner>
            <StartDateAndLocationContainer {...props} />
        </EventDetailsMainInner>
    );
};
